<!--
  - Copyright (c) 2023. Henry Zilek
  -->

<template>
    <section class="side-menu-container">


        <section class="side-menu">
            <div class="local-logo">
            <img alt="logo" class="logo" src="@/assets/notigo_logo_web.svg">
        </div>
            <div class="side-menu-block">
                <div :class="{active:!this.$store.state.mobileMenuActive}">
                    <div
                            class="onMobile top-margin">
                        <MenuItem v-for="item in menuList" :key="item"
                                  :class="{active:!this.$store.state.mobileMenuActive}"
                                  :menu-object="item"
                                  class="side-item-item-large font-style-bold" @click="setInactive"/>
                    </div>
                    <div class="separator top-margin"></div>
                    <div class="top-margin">
                        <MenuItem
                                v-for="item in $store.state.socialMenu" :key="item"
                                :class="{active:!this.$store.state.mobileMenuActive}" :menu-object="item"
                                class="side-item-item font-style-regular"/>
                        <HZBaseButton
                                :target="'mailto:' + this.$store.state.webEmail"
                                class="button-only-frame button-blue ">Pro nové klienty
                        </HZBaseButton>
                        <HZBaseButton v-if="(this.$store.state.develop || this.$store.state.isAdmin)"
                                :target="{text: 'Admin', name: 'Admin', type:'default', hash: '', fa_icon:''}"
                                class="button-no-frame button-grey ">Administrace
                        </HZBaseButton>
                    </div>
                </div>
            </div>
        </section>

        <div class="mobile-header">
            <span class="mobile-logo">
                <img alt="logo" class="logo" src="@/assets/notigo_logo_web.svg">
            </span>
            <div v-if="!this.$store.state.mobileMenuActive && !showTabletMenu" class="toggle-nav" @click="changeActive"><i class="fa-regular fa-bars"></i></div>
            <div v-else class="toggle-nav" @click="goBack"><i class="fa-regular fa-xmark"></i></div>
            <div class="tabletMenu" :class="{showTabletMenu: showTabletMenu}">
                <div class="side-menu-block">
                    <div >
                        <div
                            class=" top-margin">
                            <MenuItem v-for="item in menuList" :key="item"
                                      :menu-object="item"
                                      class="side-item-item-large font-style-bold" @click="setInactive"/>
                        </div>
                        <div class="separator top-margin"></div>
                        <div class="top-margin">
                            <MenuItem
                                v-for="item in $store.state.socialMenu"
                                :key="item"
                                :menu-object="item"
                                class="side-item-item font-style-regular"/>
                            <HZBaseButton
                                :target="'mailto:' + this.$store.state.webEmail"
                                class="button-only-frame button-blue ">Pro nové klienty
                            </HZBaseButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import MenuItem from "@/components/menu/MenuItem.vue";
import HZBaseButton from "@/support/HZBaseButton.vue";
import router from "@/routes";

export default {
    name: "SideMenu",
    components: {MenuItem, HZBaseButton},
    data(){
        return{
            showTabletMenu: false
        }
    },

    methods: {
        changeActive() {
            if (this.$store.state.width <=1280 &&  this.$store.state.width >=500 ){
                    this.showTabletMenu =  true;
            }else {
                this.$store.commit('setMobileMenuActiveStatus', !this.$store.state.mobileMenuActive);
                router.push({name: 'Menu'});
            }

        },

        setInactive() {
            if (this.$store.state.width <=1280 &&  this.$store.state.width >=500 ){
                this.showTabletMenu =  false;
            }else {
                this.$store.commit('setMobileMenuActiveStatus', false);
            }
        },
        goBack() {
            if (this.$store.state.width <=1280 &&  this.$store.state.width >=500 ){
                this.showTabletMenu =  false;
            }else {
                this.$store.commit('setMobileMenuActiveStatus', false);
                router.go(-1);
            }
        }
    },

    computed: {
        menuList() {
            return this.$store.state.sideMenu
        }
    },

    mounted() {
        this.emitter.on('a-far-away-event', (event) => {
            this.sup.hzLog("On emitter handler: " + event);
            alert('A long way to come!');
        })
        this.emitter.on('*', (event) => {
            this.sup.hzLog("On emitter handler: " + event);
            alert('ted to je cokoli');
        })
    }
}
</script>

<style scoped>

.mobile-logo, .mobile-header {
    display: none;
}

.tabletMenu{
    display: none;
}

.tabletMenu.showTabletMenu{
    display: flex;
    position: absolute;
    top:50px;
    right: 0px;
    width: 300px;
    height: 100vh;
    padding: 0 20px 20px 50px;
    background-color: var(--not-dark-magenta);
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    overflow-y: auto;
    box-shadow: 0px 5px 15px #00000026;
}

.side-menu-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
}

.side-menu {
    width: var(--not-side-menu-panel);
    height: 100%;
    padding: 0 20px 20px 75px;
    background-color: var(--e-global-color-primary);

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    overflow-y: auto;
}

.side-item-item, .side-item-item-large {
    margin-bottom: 30px;
}

.side-item-item:last-of-type, .side-item-item-large:last-of-type {
    margin-bottom: unset;
}


.separator {
    width: 60%;
    height: 1px;
    border-bottom: solid 1px var(--e-global-color-secondary);
}

.onMobile {

}

.partial-menu {
    margin: 70px 0;
}

.top-margin {
    margin-top: 40px;
}

.local-logo {
    max-height: 100px;
    margin-top: 10px;
    background-color: var(--e-global-color-primary);
}

.logo {
    width: 220px;
}

@media screen and (max-width: 1650px) {


    .top-margin {
        margin-top: 30px;
    }

    .font-style-bold {
        font: var(--not-font-style-normal) normal var(--not-font-weight-bold) 16px/var(--not-line-spacing-24) var(--not-font-family-montserrat);
        letter-spacing: var(--not-character-spacing-0);
    }

    .side-menu {
        padding-left: 55px;
    }
}

@media screen and (max-width: 1560px) {
    .logo {
        width: 200px;
    }
}


@media screen and (max-width: 1280px) {
    .logo {
        width: 180px;
        padding: 10px 30px;
    }
    .side-menu {
        padding-left: 50px;
        display: none;
    }
    .mobile-logo {
        display: inline-block;
        margin-left: 10px;
    }
    .mobile-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        background-color: var(--not-dark-magenta);
        box-shadow: 0px 0px 15px #00000026;
    }
    .toggle-nav {
        margin-right: 40px;
    }
    .fa-bars, .fa-xmark {
        font-size: 0.8em;
    }

    .side-item-item, .side-item-item-large {
        margin-bottom: 20px;
    }

    .font-style-bold {
        font: var(--not-font-style-normal) normal var(--not-font-weight-bold) 16px/var(--not-line-spacing-20) var(--not-font-family-montserrat);
        letter-spacing: var(--not-character-spacing-0);
    }
}

@media screen and (max-width: 860px) {
    .mobile-logo {
        display: inline-block;
        margin-left: 10px;
    }

    .mobile-header {
        display: flex;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background-color: var(--not-dark-magenta);
    }


    .side-menu {
        width: calc(100vw - 20px);
        height: var(--not-mobile-nav-bar);
        padding: 10px;
        background-color: var(--e-global-color-primary);
        position: absolute;
        left: 0;
        top: 0;
        text-align: left;
        display: none;

    }

    .local-logo {
        display: none;
    }

    .toggle-nav {
        margin-right: 50px;
    }
    .fa-bars, .fa-xmark {
        font-size: 0.9em;
    }

    .logo {
        height: 65px;
        width: auto;
        padding: 10px 0 10px 40px;
    }

    .onMobile {
        display: none;
        background-color: var(--not-dark-magenta);
        width: 120vw;
        height: 200vh;
        z-index: 100;
        position: absolute;
        top: var(--not-mobile-nav-bar);
        padding-top: 10px;
        padding-left: 50px;
        padding-right: 50px;
    }
}

@media screen and (max-height: 740px) {
    .side-menu {
        justify-content: flex-start;
    }
}

@media screen and (max-width: 480px) {
    .logo {
        width: 160px;
        padding: 10px 0 10px 20px;
    }
    .fa-bars, .fa-xmark {
        font-size: 0.7em;
    }

    .side-menu-block {
        display: none;
    }

    .side-menu {
        display: block;
        width: 100vw;
        height: var(--not-mobile-nav-bar);
        padding: 10px;
        background-color: var(--not-dark-magenta);
        position: fixed;
        left: 0;
        top: 0;
        text-align: left;
    }

    .toggle-nav {
        margin-right: 30px;
    }


}
</style>